/*******************************************************************************
GET ARTICLES
Returns a set of articles.
*******************************************************************************/

import showErrorNotificationBar from '../../universal/error-handling/show-error-notification-bar';

export default async function getArticles(settings) {
    try {

        // Optional Settings
        const options = {};
        if (settings.content) { options.content = settings.content; }
        if (settings.sport) { options.sport = settings.sport; }
        if (settings.column) { options.column = settings.column; }
        if (settings.author) { options.author = settings.author; }
        if (settings.noColumnInHeadline) { options.noColumnInHeadline = settings.noColumnInHeadline; }
        if (settings.lastArticleDate) { options.lastArticleDate = settings.lastArticleDate; }
        if (settings.numArticles) { options.numArticles = settings.numArticles; }
        if (settings.exclude) { options.exclude = settings.exclude; }

        const response = await $.ajax({
            type   : 'GET',
            url    : '/frontend/ajax/get-articles.php',
            data   : options,
            timeout: 8000,
        });

        // Check for errors with the data
        if (response.error || !response.success) { throw new Error(response.error); }

        // Return the data
        return {
            articles          : response.articles,
            articlesHTML      : response.articlesHTML,
            newLastArticleDate: response.lastArticleDate,
            noMoreArticles    : response.noMoreArticles,
        };
    }
    catch (error) {
        showErrorNotificationBar(error.message || 'We were unable to retrieve articles for you. Please try again.', 3000);
    }
}
